import { CardContent } from '../../content.types';

const continueButton = {
  displayText: 'Continue',
  url: '/home',
  color: 'primary' as const,
};

export const inviteCaregiverSectionCard: CardContent = {
  overline: 'Caregivers',
  header: 'Invite another caregiver',
  subheader:
    'Share access with another caregiver so they can manage your child’s care.',
  body: 'Inviting a caregiver gives them access to your child’s care plan and lets them message providers.',
  buttons: [
    {
      displayText: 'Invite caregiver',
      url: '/account/invite-caregiver',
      color: 'primary',
    },
  ],
};

export const shareChildAccessCard: CardContent = {
  overline: 'Share access',
  header: 'Share your child’s care',
  subheader: 'Invite another caregiver to help manage care.',
  buttons: [
    {
      displayText: 'Share access',
      url: '/account/invite-caregiver',
      color: 'primary',
    },
  ],
};

export const insuranceCoveredCard: CardContent = {
  overline: 'Insurance',
  header: 'You’re covered!',
  subheader: 'Your insurance covers Summer Health.',
  buttons: [continueButton],
};

export const insuranceNotCoveredCard: CardContent = {
  overline: 'Insurance',
  header: 'Insurance not yet supported',
  subheader: 'You can still join with a subscription.',
  buttons: [
    {
      displayText: 'Choose a plan',
      url: '/signup/plan-selection',
      color: 'primary',
    },
    {
      displayText: 'Notify me when available',
      url: '/signup/notify-coverage',
      color: 'secondary',
    },
  ],
};

export const notifyCoverageCard: CardContent = {
  overline: 'Insurance',
  header: 'We’ll notify you',
  subheader: 'You’ll get an email when we support your insurance.',
  buttons: [
    {
      displayText: 'Continue',
      url: '/signup/plan-selection',
      color: 'primary',
    },
  ],
};

export const insuranceCompleteCard: CardContent = {
  overline: 'Insurance',
  header: 'Insurance complete',
  subheader: 'Your insurance has been added.',
  buttons: [
    {
      displayText: 'Continue',
      url: '/onboarding/complete',
      color: 'primary',
    },
  ],
};

export const insuranceUploadCard: CardContent = {
  overline: 'Insurance',
  header: 'Upload your insurance card',
  subheader:
    'Take a photo of %child_name%’s insurance card so we can verify coverage.',
  body: 'Make sure the card is well-lit and all details are visible.',
  buttons: [
    {
      displayText: 'Upload photo',
      url: '#',
      color: 'primary',
    },
  ],
};

export const insuranceVerifyCard: CardContent = {
  overline: 'Insurance',
  header: 'Verifying insurance for %child_name%',
  subheader: 'This usually takes a few seconds.',
  body: 'Hang tight while we confirm your coverage.',
  buttons: [],
};

export const insuranceUploadCompleteCard: CardContent = {
  overline: 'Insurance',
  header: 'All set',
  subheader: 'We’ll verify your coverage shortly.',
  buttons: [
    {
      displayText: 'Continue',
      url: '/onboarding/complete',
      color: 'primary',
    },
  ],
};

export const screeningTaskCard: CardContent = {
  overline: 'Developmental screening',
  header: 'Time for a check-in',
  subheader: 'A short questionnaire about %month%-month milestones.',
  buttons: [
    {
      displayText: 'Start',
      url: '#',
      color: 'primary',
    },
  ],
};

export const planDetailsCard: CardContent = {
  header: 'Your plan',
  body: 'Your Summer Health plan covers texting with our pediatric care team.',
  buttons: [],
};

export const planDetailsPaygCard: CardContent = {
  header: 'Pay-per-visit',
  body: 'Pay only for the visits you use. No subscription required.',
  buttons: [],
};

export const cards: Record<string, CardContent> = {
  '6emrvQs3RobzGrJAjiYqyi': inviteCaregiverSectionCard,
  nlvi0CQX6UgF1UVLmzwlZ: shareChildAccessCard,
  '3hAGgVY725JqXiodRXFb37': insuranceCoveredCard,
  '4wPxwod8kpLHOTUjPAVvJb': insuranceNotCoveredCard,
  '1LEwaFulEDBgkrEtuuTDo1': notifyCoverageCard,
  '1R2grzstOV4jy3MEhccJWj': insuranceCompleteCard,
  '7HXIJsEzfcwcb29cpqYMGy': insuranceUploadCard,
  '4G7qGG4mE9AGUIW367goIV': insuranceVerifyCard,
  '7K3NnpHuLvQK9lAYmdomQ6': screeningTaskCard,
  '5PXIp8ONMjfw8achHTdxcZ': planDetailsPaygCard,
  '7A5u7SSslzKdhNcSJohTTA': planDetailsCard,
};
